<script lang="ts" setup>
import type { UseFinancingsParams } from '~/store-v2/financings/useFinancings'
import { SolSelect } from '@solfacil/girassol'
import QuickFilters from './QuickFilters.vue'

const props = defineProps<{
  sortBy: { name: string, value: string }
  sortByOptions: Array<{ name: string, value: string }>
  params: UseFinancingsParams
}>()

const emit = defineEmits<{
  (e: 'update:sortBy', value: { name: string, value: string }): void
  (e: 'update:params', params: Partial<UseFinancingsParams>): void
  (e: 'hasActiveQuickFilter', hasActive: boolean): void
}>()

const { t } = useI18n()

const sortByModel = computed({
  get: () => props.sortBy,
  set: value => emit('update:sortBy', value),
})
</script>

<template>
  <div class="list-actions">
    <div class="list-actions-content">
      <QuickFilters
        :params="params"
        @update:params="emit('update:params', $event)"
        @has-active-filter="emit('hasActiveQuickFilter', $event)"
      />
      <div class="list-actions-sort">
        <h2 class="text-brand-primary-pure font-bold self-center mr-micro">
          {{ t('financing.sort_by.label') }}
        </h2>
        <div class="w-56">
          <SolSelect
            id="financing-order-by"
            v-model:selected="sortByModel"
            name="financing-order-by"
            size="small"
            :options="sortByOptions"
          >
            <template #no-data>
              <h2 class="text-feedback-negative-pure font-bold">
                {{ t('financing.no_data') }}
              </h2>
            </template>
          </SolSelect>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list-actions {
  @apply mb-4;

  .list-actions-content {
    @apply flex flex-col gap-4;

    @screen md:system {
      @apply flex-row items-center justify-between;
    }
  }

  .list-actions-sort {
    @apply flex items-center;

    @screen max-md:system {
      @apply justify-end;
    }
  }
}
</style>
